'use client';

import { Button } from '@pickleballinc/react-ui';
import getPBracketsCDNURL from '@pickleballinc/ui/components/global/utils/getPBracketsCDNURL';

import { SponsorData } from '@/modules/league/new-components/types';
import { PBRACKETS_UPLOADS_ROOT } from '@/utils/helpers/constants';

interface SponsorsProps {
  leagueId: string;
  clubId: string;
  sponsorGroups: SponsorData[][];
}

const Sponsors = ({ leagueId, clubId, sponsorGroups }: SponsorsProps) => {
  const getSponsorLogoURL = (sponsor: SponsorData) => {
    const url = `${PBRACKETS_UPLOADS_ROOT}/${
      sponsor.Logo?.toLowerCase().startsWith('clubs/')
        ? sponsor.Logo
        : `clubs/${clubId}/${sponsor.Logo}`
    }`;

    return getPBracketsCDNURL(url, 400, 400);
  };

  return (
    <div className='md:mx-4 flex flex-col w-full bg-transparent gap-6 pt-6'>
      <a
        href={`https://contact.${process.env.NEXT_PUBLIC_REWRITE_DOMAIN_NAME}/contacts/league/${leagueId}`}
        target='_blank'
        className='ml-auto'
        aria-label='Link to a become a sponsor form (opens in a new tab)'
        rel='noreferrer'
      >
        <Button size='xl' variant='secondary' className='bg-white'>
          Become a Sponsor
        </Button>
      </a>
      {sponsorGroups.length > 0 &&
        sponsorGroups.map((sponsors, index) => {
          const sponsorRoot = sponsors[0];
          return (
            <div
              key={`sponsor-card-${sponsorRoot?.SponsorLevelTitle}-${index}`}
              className='w-full flex flex-col gap-4 rounded-lg p-4 sm:gap-6 sm:p-4 mb-6 bg-white shadow-xs'
            >
              <div className='flex flex-row items-center justify-between'>
                <div className='text-lg font-bold text-primary-700 sm:text-2xl'>
                  {sponsorRoot?.SponsorLevelTitle || ''}
                </div>
              </div>
              <div className='grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-5'>
                {sponsors.map((sponsor, i) => (
                  <div key={`sponsor-image-${sponsor.Title}-${i}`}>
                    {sponsor.URL ? (
                      <a
                        href={
                          sponsor.URL?.includes('http') ? sponsor.URL : `https://${sponsor.URL}`
                        }
                        target='_blank'
                        aria-label={`Link to ${sponsor.Title} page (opens in a new tab)`}
                        rel='noreferrer'
                      >
                        <img
                          src={getSponsorLogoURL(sponsor)}
                          alt={`${sponsor.Title} logo`}
                          className='h-32 w-full rounded-lg border bg-white object-contain p-2'
                        />
                      </a>
                    ) : (
                      <img
                        src={getSponsorLogoURL(sponsor)}
                        alt={`${sponsor.Title} logo`}
                        className='h-32 w-full rounded-lg border bg-white object-contain p-2'
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default Sponsors;
